<template>
  <div id="firebaseui-auth-container" v-if="!user"></div>
  <div v-else>
    <div>Email: {{user.email}}</div>
    <span class="btn btn-primary" @click="signout">Signout</span>
  </div>
</template>
<script>
import firebase from 'firebase/app'
import * as firebaseui from 'firebaseui'
import 'firebaseui/dist/firebaseui.css'
import { trackEvent } from '@/utils/analytics'
export default {
  data() {
    return {
      authUi: null
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    }
  },
  mounted() {
    this.authUi = new firebaseui.auth.AuthUI(firebase.auth())
    if (this.user === null) this.renderLoginUi()
  },
  methods: {
    signout() {
      firebase.auth().signOut()
    },
    renderLoginUi() {
      const vm = this
      const uiConfig = {
        // signInSuccessUrl: '/',
        callbacks: {
          signInSuccessWithAuthResult(authResult) {
            // User successfully signed in.
            // Return type determines whether we continue the redirect automatically
            // or whether we leave that to developer to handle.
            const user = authResult.user
            const isNewUser = authResult.additionalUserInfo.isNewUser
            if (isNewUser) {
              user.sendEmailVerification()
              trackEvent('user registered', {
                eventCategory: 'user',
                eventAction: 'register',
                eventLabel: user.email
              })
            }
            vm.$emit('signin')
            trackEvent('user signin', {
              eventCategory: 'user',
              eventAction: 'signin',
              eventLabel: user.email
            })
            return false
          },
          uiShown() {
            // The widget is rendered.
            // Hide the loader.
            // document.getElementById('loader').style.display = 'none';
          }
        },
        signInOptions: [
          // firebase.auth.GoogleAuthProvider.PROVIDER_ID,
          firebase.auth.EmailAuthProvider.PROVIDER_ID,
          firebase.auth.GoogleAuthProvider.PROVIDER_ID,
          firebase.auth.FacebookAuthProvider.PROVIDER_ID
        ],
        signInFlow: 'popup',
        credentialHelper: firebaseui.auth.CredentialHelper.NONE
      }
      this.authUi.start('#firebaseui-auth-container', uiConfig)
    }
  },
  watch: {
    user() {
      if (this.user === null) this.$nextTick(() => this.renderLoginUi())
    }
  },
  beforeDestroy() {
    this.authUi.delete()
  }
}
</script>
